import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  ProgressBar,
} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import styles from "./CatalogueDownload.module.css";
import { useLocation } from "react-router-dom";
import CataloguePDFDocument from "./CataloguePDFDocument";
import { PDFDownloadLink,pdf } from "@react-pdf/renderer";

const CatalogueDownload = () => {
  const location = useLocation();
  const { title, products, isMargin } = location.state || {};

  const [step, setStep] = useState(1);
  const [pdfLoading, setPdfLoading] = useState(false);
  
  const initialValues = {
    companyName: "",
    fullName: "",
    contact: "",
    marginType: "value", // default
    marginValue: 0, // default
    building: "",
    road: "",
    remarks: "",
  };

  const validationSchema = Yup.object({
    companyName: Yup.string().required("Company Name is required"),
    fullName: Yup.string().required("Full Name is required"),
    marginValue: Yup.number()
      .typeError("Must be a number")
      .required("Margin is required"),
  });

  // PDF EXPORT FIRST TABLE
  const handleSubmit = async (values) => {
    if (!products || products.length <= 0) {      
      return;
    }
  
    try {
      setPdfLoading(true); // Start loader
  
      const blob = await pdf(
        <CataloguePDFDocument
         products={products}
         mainHeading={title?.main}
         subHeading={title?.sub}
         subSubHeading={title?.subSub}         
         company={values}
         remarks={values?.remarks} />
      ).toBlob();
  
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${title?.main}_${title?.sub}_Catalogue.pdf`;
      link.click();
  
      URL.revokeObjectURL(url);
    } catch (error) {
      // console.error("PDF export error:", error);
    } finally {
      setPdfLoading(false); // Stop loader
    }
  };
  

  return (
    <div className={styles.wrapper}>
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={4} lg={5} md={7} sm={10} xs={12}>
            <Card className={styles.card}>
              <Card.Body>

                <div className={styles.headingBox}>
                {title && (
                    <>
                      {title?.main && (
                        <h5 className={styles.mainHeading}>
                          {title.main}
                        </h5>
                      )}

                      {title?.sub && (
                        <div className={styles.subHeading}>
                          {title.sub}
                        </div>
                      )}

                      {title?.subSub && (
                        <div className={styles.subSubHeading}>
                          {title.subSub}
                        </div>
                      )}
                    </>
                  )}
                  <small className={styles.downloadText}>
                    Fill details to download catalogue
                  </small>
                </div>

                <ProgressBar
                  now={step === 1 ? 50 : 100}
                  className="mb-3"
                  style={{ height: "4px" }}
                />

                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    validateForm,
                    setTouched,
                  }) => (
                    <Form onSubmit={handleSubmit}>

                      {/* STEP 1 */}
                      {step === 1 && (
                        <>
                          <Row>
                            <Col xs={12}>
                              <Form.Group className="mb-2">
                                <Form.Label className={styles.label}>
                                  Company Name *
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="companyName"
                                  className={styles.smallInput}
                                  value={values.companyName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.companyName &&
                                    errors.companyName
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.companyName}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>

                            <Col xs={12}>
                              <Form.Group className="mb-2">
                                <Form.Label className={styles.label}>
                                  Full Name *
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="fullName"
                                  className={styles.smallInput}
                                  value={values.fullName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.fullName && errors.fullName
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.fullName}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>

                            <Col xs={12} md={6}>
                              <Form.Group className="mb-2">
                                <Form.Label className={styles.label}>
                                  Contact
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="contact"
                                  className={styles.smallInput}
                                  value={values.contact}
                                  onChange={handleChange}
                                />
                              </Form.Group>
                            </Col>
                            {isMargin && (                            
                             <>
                              <Col xs={12} md={6}>
                                <Form.Group className="mb-2">
                                  <Form.Label className={styles.label}>
                                    Margin Type
                                  </Form.Label>
                                  <Form.Select
                                    name="marginType"
                                    className={styles.smallInput}
                                    value={values.marginType}
                                    onChange={handleChange}
                                  >
                                    <option value="value">Value</option>
                                    <option value="percent">Percent</option>
                                  </Form.Select>
                                </Form.Group>
                              </Col>

                              <Col xs={12}>
                                <Form.Group className="mb-2">
                                  <Form.Label className={styles.label}>
                                    {values.marginType === "percent"
                                      ? "Margin % *"
                                      : "Margin Value *"}
                                  </Form.Label>
                                  <Form.Control
                                    type="number"
                                    name="marginValue"
                                    className={styles.smallInput}
                                    value={values.marginValue}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={
                                      touched.marginValue &&
                                      errors.marginValue
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.marginValue}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </>   
                            )}
                          </Row>

                          <div className="text-end mt-3">
                            <Button
                              size="sm"
                              onClick={async () => {
                                const formErrors = await validateForm();
                                if (
                                  !formErrors.companyName &&
                                  !formErrors.fullName &&
                                  !formErrors.marginValue
                                ) {
                                  setStep(2);
                                } else {
                                  setTouched({
                                    companyName: true,
                                    fullName: true,
                                    marginValue: true,
                                  });
                                }
                              }}
                            >
                              Next →
                            </Button>
                          </div>
                        </>
                      )}

                      {/* STEP 2 */}
                      {step === 2 && (
                        <>
                          <Form.Group className="mb-2">
                            <Form.Label className={styles.label}>
                              Building/Floor/Flat No.
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              name="building"
                              className={styles.smallTextarea}
                              value={values.building}
                              onChange={handleChange}
                            />
                          </Form.Group>

                          <Form.Group className="mb-2">
                            <Form.Label className={styles.label}>
                              Road / Area
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              name="road"
                              className={styles.smallTextarea}
                              value={values.road}
                              onChange={handleChange}
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className={styles.label}>
                              Remarks/Note
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              name="remarks"
                              className={styles.smallTextarea}
                              value={values.remarks}
                              onChange={handleChange}
                            />
                          </Form.Group>

                          <div className="d-flex justify-content-between mt-3">
                            <Button
                              variant="secondary"
                              size="sm"
                              onClick={() => setStep(1)}
                            >
                              ← Back
                            </Button>

                            <Button variant="success" size="sm"
                             type="submit">
                              {pdfLoading ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  Downloading...
                                </>
                              ) : (
                                "Download"
                              )}                              
                            </Button>
                          </div>
                        </>
                      )}
                    </Form>
                  )}
                </Formik>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CatalogueDownload;
